import React from 'react';
import NavBar from './components/Navbar';
import Main from './components/Main';
import Footer from './components/Footer';
import About from './components/About';
import Services from './components/Services';
import MyProjects from './components/Projects';
import Contact from './components/Contact';

function App() {
  return (
    <div>
      <NavBar />
      <Main />
      <About />
      <Services />
      <MyProjects />
      <Contact/>
      <Footer />
    </div>
  );
}

export default App;
